<template>
  <div v-if="show" class="loading"></div>
</template>

<script>
  export default {
    data() {
      return {
        show: false
      }
    },
    created() {
      this.$EventBus.listen(this, 'loading', (bln) => {
        // this.$utils.enableScroll(!bln)
        this.show = bln
      })
    }
  }
</script>